export default {
  // 日期时间格式化
  formartDateTime: function (dateTime, formartStr) {
    if (typeof (dateTime) !== 'object') {
      return ''
    }
    if (!(dateTime instanceof Date)) {
      return ''
    }
    const year = dateTime.getFullYear() + ''
    const year2 = year.substring(2, 2)
    const month = dateTime.getMonth() + 1
    const day = dateTime.getDate()
    const monthStr = month < 10 ? ('0' + month) : ('' + month)
    const dayStr = day < 10 ? ('0' + day) : ('' + day)
    const hour = dateTime.getHours()
    const hourStr = hour < 10 ? ('0' + hour) : ('' + hour)
    const minute = dateTime.getMinutes()
    const minuteStr = minute < 10 ? ('0' + minute) : ('' + minute)
    const second = dateTime.getSeconds()
    const secondStr = second < 10 ? ('0' + second) : ('' + second)
    if (formartStr) {
      return formartStr.replace(/yyyy/g, year)
        .replace(/yy/g, year2)
        .replace(/MM/g, monthStr)
        .replace(/dd/g, dayStr)
        .replace(/HH/g, hourStr)
        .replace(/mm/g, minuteStr)
        .replace(/ss/g, secondStr)
    } else {
      return '' + year + '-' + monthStr + '-' + dayStr
    }
  },

  // 日期时间加减(精确到秒)
  addDateTime: function (dateTime, type, num, formartStr) {
    const that = this
    if (typeof (dateTime) === 'string') {
      dateTime = new Date(dateTime)
    }
    if (isNaN(dateTime.getFullYear())) {
      return ''
    }
    const year = dateTime.getFullYear()
    const month = dateTime.getMonth()
    const day = dateTime.getDate()
    const hour = dateTime.getHours()
    const minute = dateTime.getMinutes()
    const second = dateTime.getSeconds()
    const rtnDateTime = new Date()
    if (typeof (type) !== 'string') {
      return ''
    } else if (type.toUpperCase() === 'YEAR') {
      rtnDateTime.setFullYear(year + num)
    } else if (type.toUpperCase() === 'MONTH') {
      rtnDateTime.setMonth(month + num)
    } else if (type.toUpperCase() === 'DAY') {
      rtnDateTime.setDate(day + num)
    } else if (type.toUpperCase() === 'HOUR') {
      rtnDateTime.setHours(hour + num)
    } else if (type.toUpperCase() === 'MINUTE') {
      rtnDateTime.setMinutes(minute + num)
    } else if (type.toUpperCase() === 'SECOND') {
      rtnDateTime.setSeconds(second + num)
    }
    if (formartStr) {
      return that.formartDateTime(rtnDateTime, formartStr)
    } else {
      return rtnDateTime
    }
  },

  // 验证是否为指定格式日期字符串
  checkDateTimeStr: function (dateTimeStr, formartStr) {
    if (!dateTimeStr) {
      return false
    } else if (typeof (dateTimeStr) !== 'string') {
      return false
    } else {
      try {
        let tempFormartStr = 'yyyy-MM-dd'
        if (formartStr) {
          tempFormartStr = formartStr
        }
        if (dateTimeStr.length < tempFormartStr.length) {
          return false
        }
        const yyyyIndex = tempFormartStr.indexOf('yyyy')
        const MMIndex = tempFormartStr.indexOf('MM')
        const ddIndex = tempFormartStr.indexOf('dd')
        const HHIndex = tempFormartStr.indexOf('HH')
        const mmIndex = tempFormartStr.indexOf('mm')
        const ssIndex = tempFormartStr.indexOf('ss')
        const yyIndex = tempFormartStr.indexOf('yy')
        const yyyyStr = yyyyIndex >= 0 ? dateTimeStr.substr(yyyyIndex, 4) : '2000'
        const MMStr = MMIndex >= 0 ? dateTimeStr.substr(MMIndex, 2) : '01'
        const ddStr = ddIndex >= 0 ? dateTimeStr.substr(ddIndex, 2) : '01'
        const HHStr = HHIndex >= 0 ? dateTimeStr.substr(HHIndex, 2) : '00'
        const mmStr = mmIndex >= 0 ? dateTimeStr.substr(mmIndex, 2) : '00'
        const ssStr = ssIndex >= 0 ? dateTimeStr.substr(ssIndex, 2) : '00'
        const yyStr = yyyyIndex >= 0 ? yyyyStr : (yyIndex >= 0 ? ('20' + dateTimeStr.substr(yyIndex, 2)) : '2000')
        const newDateTimeStr = yyStr + '-' + MMStr + '-' + ddStr + ' ' + HHStr + ':' + mmStr + ':' + ssStr
        const newDateTime = new Date(newDateTimeStr)
        if (newDateTime) {
          return true
        }
        return false
      } catch {
        return false
      }
    }
  },

  // 指定格式日期字符串转日期
  dateTimeStrToDateTime: function (dateTimeStr, formartStr) {
    if (!dateTimeStr) {
      return null
    } else if (typeof (dateTimeStr) !== 'string') {
      return null
    } else {
      try {
        let tempFormartStr = 'yyyy-MM-dd'
        if (formartStr) {
          tempFormartStr = formartStr
        }
        if (dateTimeStr.length < tempFormartStr.length) {
          return null
        }
        const yyyyIndex = tempFormartStr.indexOf('yyyy')
        const MMIndex = tempFormartStr.indexOf('MM')
        const ddIndex = tempFormartStr.indexOf('dd')
        const HHIndex = tempFormartStr.indexOf('HH')
        const mmIndex = tempFormartStr.indexOf('mm')
        const ssIndex = tempFormartStr.indexOf('ss')
        const yyIndex = tempFormartStr.indexOf('yy')
        const yyyyStr = yyyyIndex >= 0 ? dateTimeStr.substr(yyyyIndex, 4) : '2000'
        const MMStr = MMIndex >= 0 ? dateTimeStr.substr(MMIndex, 2) : '01'
        const ddStr = ddIndex >= 0 ? dateTimeStr.substr(ddIndex, 2) : '01'
        const HHStr = HHIndex >= 0 ? dateTimeStr.substr(HHIndex, 2) : '00'
        const mmStr = mmIndex >= 0 ? dateTimeStr.substr(mmIndex, 2) : '00'
        const ssStr = ssIndex >= 0 ? dateTimeStr.substr(ssIndex, 2) : '00'
        const yyStr = yyyyIndex >= 0 ? yyyyStr : (yyIndex >= 0 ? ('20' + dateTimeStr.substr(yyIndex, 2)) : '2000')
        const newDateTimeStr = yyStr + '-' + MMStr + '-' + ddStr + ' ' + HHStr + ':' + mmStr + ':' + ssStr
        const newDateTime = new Date(newDateTimeStr)
        if (newDateTime) {
          return newDateTime
        }
        return null
      } catch {
        return null
      }
    }
  }
}
